import React, { FC } from "react";
import { makeStyles } from "@material-ui/core";
import { TheCycleverseTheme } from "src/theme";
import ButtonLink from "src/components/Navigation/ButtonLink";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  button: {
    backgroundColor: theme.buttonBackgroundColor,
    color: theme.buttonColor,
    textAlign: "center",
    "&:hover": {
      backgroundColor: theme.buttonBackgroundColor,
    },
    marginTop: "30px",
    marginBottom: "30px",
    cursor: "pointer",
  },

  center: {
    textAlign: "center",
  },
}));

export const CalculatorButtonLinkCentered: FC<{
  text: string;
  href: string;
}> = ({ text, href }) => {
  const classes = useStyles();

  return (
    <div className={classes.center}>
      <ButtonLink href={href} as={href} buttonClassName={classes.button} target="new">
        {text}
      </ButtonLink>
    </div>
  );
};
